class CollapsibleLanguageMenu extends Collapsible {
  constructor() {
    super();

  }

  events() {
      super.events();

  }

  open(group) {
    super.open(group);

  }

  close(group) {
    super.close(group);

  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
  }

  openAll() {
    super.openAll();
  }

  closeAll() {
    super.closeAll();
  }
}

if (!customElements.get('collapsible-language-menu')) {
  customElements.define('collapsible-language-menu', CollapsibleLanguageMenu);
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      panel: this.querySelector('ul'),
      proxyInput: this.querySelector('input[type="text"]')
    };

    this.elements.panel
      .querySelectorAll('a')
      .forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));

    this.elements.proxyInput?.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onKeyUp(event) {
    if (event.key !== 'Enter') return;

    const form = this.querySelector('form');
    if (!form) return;

    form.submit();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}
customElements.define('localization-form', LocalizationForm);
